import {
  AddressesService
} from '@/common/api.service'
import {
  FETCH_ADDRESSES,
  FETCH_ADDRESS,
  ADDRESS_CREATE,
  ADDRESS_UPDATE,
  ADDRESS_DELETE
} from './actions.type'
import {
  FETCH_START,
  FETCH_END,
  SET_ADDRESS
} from './mutations.type'

const state = {
  addresses: [],
  isLoading: true,
  addressesCount: 0
}

const getters = {
  addressesCount (state) {
    return state.addressesCount
  },
  addresses (state) {
    return state.addresses
  }
}

const actions = {
  [FETCH_ADDRESSES] ({ commit }, params) {
    commit(FETCH_START)
    return AddressesService.query(params.type, params.filters)
      .then(({ data }) => {
        let collection = { addresses: data.data, addressesCount: data.pagination.total }
        commit(FETCH_END, collection)
      })
      .catch((error) => {
        throw new Error(error)
      })
  },
  [FETCH_ADDRESS] (context, addressId) {
    return AddressesService.get(addressId)
      .then(({ data }) => {
        context.commit(SET_ADDRESS, data)
        return data
      })
  },
  [ADDRESS_CREATE] ({state}, item) {
    return AddressesService.create(item)
  },
  [ADDRESS_UPDATE] ({state}, [id, item]) {
    return AddressesService.update(id, item)
  },
  [ADDRESS_DELETE] (context, id) {
    return AddressesService.destroy(id)
  }
}

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_START] (state) {
    state.isLoading = true
  },
  [FETCH_END] (state, { addresses, addressesCount }) {
    // console.log(shippingsCount)
    state.addresses = addresses
    state.addressesCount = addressesCount
    state.isLoading = false
  },
  [SET_ADDRESS] (state, address) {
    state.address = address
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
